import { render, staticRenderFns } from "./PanelContainersGroup.vue?vue&type=template&id=6278471a&scoped=true"
import script from "./PanelContainersGroup.vue?vue&type=script&lang=js"
export * from "./PanelContainersGroup.vue?vue&type=script&lang=js"
import style0 from "./PanelContainersGroup.vue?vue&type=style&index=0&id=6278471a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278471a",
  null
  
)

export default component.exports